import { render, staticRenderFns } from "./product-material-detail.vue?vue&type=template&id=031ad883&scoped=true"
import script from "./product-material-detail.vue?vue&type=script&lang=ts"
export * from "./product-material-detail.vue?vue&type=script&lang=ts"
import style0 from "./product-material-detail.vue?vue&type=style&index=0&id=031ad883&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031ad883",
  null
  
)

export default component.exports